import { render, staticRenderFns } from "./ActivityTitle.vue?vue&type=template&id=637de0c8&scoped=true"
import script from "./ActivityTitle.vue?vue&type=script&lang=js"
export * from "./ActivityTitle.vue?vue&type=script&lang=js"
import style0 from "./ActivityTitle.vue?vue&type=style&index=0&id=637de0c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637de0c8",
  null
  
)

export default component.exports